



































import {Component, Prop, Vue} from "vue-property-decorator";
import {numToKMB} from "@/script/util"

@Component({
    components: {},
})

export default class CommunityCard extends Vue {
    @Prop() community!: any;

    private bannerImg: string = "/img/1500_300_com_banner_default.png";
    private profileImg: string = '/img/100_100_com_profile_default.png';

    mounted() {
        if (this.community.banner_img) this.bannerImg = this.community.banner_img;
        if (this.community.profile_img) this.profileImg = this.community.profile_img;

    }


    moveCommunity() {
        this.$router.push(`/${this.$i18n.locale}/community/${this.community.id}/timeline`)
    }
    moveMemberList(){
        this.$router.push(`/${this.$i18n.locale}/community/${this.community.id}/members`)
    }

//    퍼블리싱 이미지 처리
    imgClass() {
        let result = '';
        if (this.$route.meta?.title === 'ManageJoinedGroup') {
            result = 'cmg-img'
        }
        else if (this.$route.meta?.title === 'CommunityList') {
            result = 'ct-img'
        }
        return result;
    }

    infoClass() {
        let result = '';
        if (this.$route.meta?.title === 'ManageJoinedGroup') {
            result = 'cmg-info'
        }
        else if (this.$route.meta?.title === 'CommunityList') {
            result = 'ct-info'
        }
        return result;
    }

    visitCnt(num: number) {
        return numToKMB(num)
    }


}
